import { useState } from "react";

import { PublicationListData } from "@/components/business/PublicationListContainer/publicationList.types";
import { ProcessStatusCode } from "@/types/code.types";
import useModal from "@hooks/useModal";

import ListCheckStatusGuide from "./components/ListTableShellForTitle/components/CheckStatusGuide/CheckStatusGuide";
import ListTableShellForTitle from "./components/ListTableShellForTitle/ListTableShellForTitle";

type Props = {
  listItem: PublicationListData;
  updatePublicationList: () => void;
  ListData: PublicationListData[];
};

const PublicationTitleContainer = ({
  updatePublicationList,
  listItem,
  ListData,
}: Props) => {
  const [targetId, setTargetId] = useState("");
  const [currentStatus, setCurrentStatus] = useState<ProcessStatusCode | "">(
    "",
  );

  const {
    isModal: isCheckStatusModal,
    closeModal: closeCheckStatusModal,
    openModal: openCheckStatusModal,
  } = useModal();

  const handleTargetId = (id: string) => {
    setTargetId(id);
  };

  const handleCurrentStatus = (status: ProcessStatusCode | "") => {
    setCurrentStatus(status);
  };

  return (
    <>
      <ListTableShellForTitle
        key={listItem.publicationId}
        publicationData={listItem}
        openCheckStatusModal={openCheckStatusModal}
        handleTargetCtgId={() => handleTargetId(listItem?.publicationId || "")}
        handleCurrentStatus={handleCurrentStatus}
      />

      {isCheckStatusModal && (
        <ListCheckStatusGuide
          closeModal={closeCheckStatusModal}
          draftArticleId={Number(targetId)}
          updatePublicationList={updatePublicationList}
          publicationListData={ListData || []}
          currentStatus={currentStatus}
        />
      )}
    </>
  );
};

export default PublicationTitleContainer;
